import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import { MetricsTableStyles } from './MetricsTableStyles';
import { withStyles } from '@material-ui/core/styles';
import DownloadIcon from '../../../theme/download';
import { formatNumber, getSelectedGeographies, getDatapointValue } from '../../../helpers';
import { CSVLink } from 'react-csv';
import ReturnToMetricLink from '../ReturnToMetricsLink';
import Track from '../../../helpers/Analytics';
import { useParams } from 'react-router-dom';

const projectTableData = (selectedMetrics, metrics, years) => {
  let metricRows = [];
  metrics.forEach(metric =>
    getSelectedGeographies(
      selectedMetrics.find(selectedMetric => selectedMetric.id === metric.id),
      metric.geographies
    ).forEach(geo => {
      const notes = metric.notes.find(n => n.geographyId === geo.id) || {};
      const methodology = metric.methodology.find(m => m.geographyId === geo.id) || {};
      metricRows.push([
        metric.name,
        geo.name,
        ...years.map(year =>
          formatNumber(getDatapointValue(metric.datapoints, year, geo.id), metric.datapoints.filter(d => d.geographies.geographyId === geo.id)[0].unit)
        ),
        notes.value || '',
        methodology.value || ''
      ]);
    })
  );
  return metricRows;
};

const TableFooter = ({ classes, showDownloadButton, metrics, selectedMetrics, allYears }) => {
  const tableData = showDownloadButton && metrics && projectTableData(selectedMetrics, metrics, allYears);
  const { metricIds } = useParams();
  const csvData = showDownloadButton && tableData && [['metric', 'geography', ...allYears, 'notes', 'methodology'], ...tableData];
  return (
    <div className={classes.tableFooter}>
      <ReturnToMetricLink />
      {showDownloadButton && (
        <Tooltip title={metrics && csvData ? 'Export .csv file' : 'No data to download'}>
          {csvData ? (
            <CSVLink className={classes.downloadCSV} data={csvData} filename={`EMARKETER_table_${metricIds}.csv`}>
              <div className={classes.download}>
                <IconButton
                  className={classes.iconButton}
                  onClick={() => {
                    Track('Metric', { id: 'Download-Data', metrics: metrics.map(m => m.name).join(', ') });
                  }}
                >
                  <div className={classes.downloadLinkText}>Export Data</div>
                  <DownloadIcon />
                </IconButton>
              </div>
            </CSVLink>
          ) : (
            <div>
              <div className={classes.download}>
                <IconButton className={classes.iconButton} disabled>
                  <div className={classes.downloadLinkText}>Export Data</div>
                  <DownloadIcon />
                </IconButton>
              </div>
            </div>
          )}
        </Tooltip>
      )}
    </div>
  );
};

export default withStyles(MetricsTableStyles)(TableFooter);
